import * as tslib_1 from "tslib";
import * as dropbox from 'dropbox';
import { readFile } from './util';
import { Data } from './data';
import { Messenger } from './messenger';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "./data";
import * as i2 from "./messenger";
var PATH_ROOT = '/FreeMasensHealthTracker';
var HISTORY_FILE = 'healthTrackerHistory.json';
var FULL_PATH = PATH_ROOT + '/' + HISTORY_FILE;
export var ServiceKind;
(function (ServiceKind) {
    ServiceKind[ServiceKind["Dropbox"] = 0] = "Dropbox";
})(ServiceKind || (ServiceKind = {}));
var RawDropboxSync = /** @class */ (function () {
    function RawDropboxSync() {
    }
    RawDropboxSync.prototype.init = function (accessToken) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ensureFileStructure(accessToken)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RawDropboxSync.prototype.extractHash = function () {
        var parts = location.hash.split('&');
        return parts.reduce(function (acc, p) {
            if (p[0] === '#') {
                p = p.substr(1);
            }
            var pair = p.split('=');
            switch (pair[0]) {
                case 'access_token':
                    acc.token = pair[1];
                    break;
                case 'uid':
                    acc.userId = pair[1];
                    break;
                case 'account_id':
                    acc.accountId = pair[1];
                    break;
            }
            return acc;
        }, { token: null,
            userId: null,
            accountId: null,
        });
    };
    RawDropboxSync.prototype.requestDropboxAuthentication = function (clientId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dbx, url;
            return tslib_1.__generator(this, function (_a) {
                console.log('requestDropboxAuthentication');
                dbx = new dropbox.Dropbox({ clientId: clientId, fetch: fetch });
                url = dbx.getAuthenticationUrl(environment.callbackUri);
                window.open(url, '_blank');
                return [2 /*return*/, url];
            });
        });
    };
    RawDropboxSync.prototype.ensureFileStructure = function (accessToken) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dbx, files, _a, file;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        dbx = new dropbox.Dropbox({ accessToken: accessToken, fetch: fetch });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 6]);
                        return [4 /*yield*/, dbx.filesListFolder({ path: PATH_ROOT })];
                    case 2:
                        files = _b.sent();
                        return [3 /*break*/, 6];
                    case 3:
                        _a = _b.sent();
                        return [4 /*yield*/, dbx.filesCreateFolderV2({ path: PATH_ROOT })];
                    case 4:
                        _b.sent();
                        return [4 /*yield*/, dbx.filesListFolder({ path: PATH_ROOT })];
                    case 5:
                        files = _b.sent();
                        return [3 /*break*/, 6];
                    case 6:
                        if (!(files.entries.length === 0)) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.sendChangesToDropbox(dbx)];
                    case 7:
                        _b.sent();
                        return [3 /*break*/, 10];
                    case 8:
                        file = files.entries.find(function (f) { return f.name === HISTORY_FILE; });
                        if (!!file) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.sendChangesToDropbox(dbx)];
                    case 9:
                        _b.sent();
                        _b.label = 10;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    RawDropboxSync.prototype.sendChangesToDropbox = function (dbx, archive) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!archive) {
                            archive = {
                                mealHistory: [],
                                bodyHistory: [],
                                weightSetHistory: []
                            };
                        }
                        return [4 /*yield*/, dbx.filesUpload({ path: FULL_PATH, contents: JSON.stringify(archive), mode: { '.tag': 'overwrite' } })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, {
                                fileModified: result.client_modified,
                                fileHash: result.content_hash
                            }];
                }
            });
        });
    };
    RawDropboxSync.prototype.getChangesFromDropbox = function (accessToken, currentHash) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dbx, metaInfo, e_1, dl, e_2, contents, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dbx = new dropbox.Dropbox({ accessToken: accessToken, fetch: fetch });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, dbx.filesGetMetadata({ path: FULL_PATH, include_deleted: false })];
                    case 2:
                        metaInfo = (_a.sent());
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        return [2 /*return*/, console.error('error getting meta info', e_1)];
                    case 4:
                        if (!(metaInfo.content_hash !== currentHash)) return [3 /*break*/, 10];
                        dl = void 0;
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, dbx.filesDownload({ path: FULL_PATH })];
                    case 6:
                        dl = _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        e_2 = _a.sent();
                        return [2 /*return*/, console.error('error downloading file', e_2)];
                    case 8:
                        if (!dl.fileBlob) return [3 /*break*/, 10];
                        return [4 /*yield*/, readFile(dl.fileBlob)];
                    case 9:
                        contents = _a.sent();
                        data = JSON.parse(contents);
                        return [2 /*return*/, {
                                archive: data,
                                fileHash: dl.content_hash,
                                fileModified: dl.client_modified,
                            }];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    RawDropboxSync.ngInjectableDef = i0.defineInjectable({ factory: function RawDropboxSync_Factory() { return new RawDropboxSync(); }, token: RawDropboxSync, providedIn: "root" });
    return RawDropboxSync;
}());
export { RawDropboxSync };
var Sync = /** @class */ (function () {
    function Sync(dbx, data, msg) {
        var _this = this;
        this.dbx = dbx;
        this.data = data;
        this.msg = msg;
        data.getDropBoxInfo().then(function (info) {
            if (!info) {
                return;
            }
            _this.dropboxInfo = info;
            _this._dropboxSync().then(function () { });
        });
    }
    Sync.prototype.requestNewDropbox = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.dbx.requestDropboxAuthentication('6qddpekngz9fnji');
                return [2 /*return*/];
            });
        });
    };
    Sync.prototype.completeDropboxSetup = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.dropboxInfo = this.dbx.extractHash();
                        return [4 /*yield*/, this.data.addDropBoxInfo(this.dropboxInfo)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.dbx.init(this.dropboxInfo.token)];
                    case 2:
                        _a.sent();
                        this.msg.send('Dropbox setup complete', false);
                        return [4 /*yield*/, this.dropboxSync()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Sync.prototype.startTimer = function (service) {
        var _this = this;
        switch (service) {
            case ServiceKind.Dropbox:
                this.dropboxTimer = setTimeout(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this._dropboxSync()];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                }); }); }, environment.dropboxTimeout);
                break;
        }
    };
    Sync.prototype._dropboxSync = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dropboxSync()];
                    case 1:
                        _a.sent();
                        this.startTimer(ServiceKind.Dropbox);
                        return [2 /*return*/];
                }
            });
        });
    };
    Sync.prototype.dropboxSync = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var lastHash, changes, fromDbx, update, dbx, newChanges;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.dropboxInfo) {
                            return [2 /*return*/, console.error('attempt to sync dropbox with no credentials')];
                        }
                        return [4 /*yield*/, this.data.getLastDropboxHash()];
                    case 1:
                        lastHash = _a.sent();
                        return [4 /*yield*/, this.dbx.getChangesFromDropbox(this.dropboxInfo.token, lastHash)];
                    case 2:
                        changes = _a.sent();
                        if (!(changes && changes.fileHash !== lastHash)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.data.importArchive(changes.archive, false)];
                    case 3:
                        fromDbx = _a.sent();
                        return [4 /*yield*/, this.data.saveDropboxChanges(changes)];
                    case 4:
                        _a.sent();
                        this.msg.send("Got " + fromDbx.meals + " meals with " + fromDbx.items + " items                , " + fromDbx.body + " measurements                 and " + fromDbx.sets + " weight sets from dropbox", false);
                        _a.label = 5;
                    case 5: return [4 /*yield*/, this.data.getAllUserData()];
                    case 6:
                        update = _a.sent();
                        dbx = new dropbox.Dropbox({ accessToken: this.dropboxInfo.token, fetch: fetch });
                        return [4 /*yield*/, this.dbx.sendChangesToDropbox(dbx, update)];
                    case 7:
                        newChanges = _a.sent();
                        return [4 /*yield*/, this.data.saveDropboxChanges(newChanges)];
                    case 8:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Sync.prototype.triggerSync = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.dropboxTimer) {
                    clearTimeout(this.dropboxTimer);
                }
                if (this.dropboxInfo) {
                    this._dropboxSync();
                }
                return [2 /*return*/];
            });
        });
    };
    Sync.prototype.hasDropboxSetup = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (!this.dropboxInfo) {
                    return [2 /*return*/, this.data.getDropBoxInfo().then(function (info) {
                            if (!info) {
                                return false;
                            }
                            _this.dropboxInfo = info;
                            return true;
                        })];
                }
                return [2 /*return*/, true];
            });
        });
    };
    Sync.prototype.stopDropbox = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.dropboxTimer) {
                            clearTimeout(this.dropboxTimer);
                        }
                        if (!this.dropboxInfo) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.data.dropboxInfo.clear()];
                    case 1:
                        _a.sent();
                        this.dropboxInfo = null;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Sync.ngInjectableDef = i0.defineInjectable({ factory: function Sync_Factory() { return new Sync(i0.inject(RawDropboxSync), i0.inject(i1.Data), i0.inject(i2.Messenger)); }, token: Sync, providedIn: "root" });
    return Sync;
}());
export { Sync };
